import { useFetch } from "./useFetch";
import servicios from "../data/servicios.json";

const HOJAS = ["Masajes", "Holisticas", "Coach"];

export const useServiciosCombinados = () => {
  const { data, cargando, error } = useFetch(HOJAS);

  const combinar = () => {
    const precios = {};
    if (!data) return [];

    for (let hoja of HOJAS) {
      if (data[hoja]) {
        const [headers, ...filas] = data[hoja];
        const ID = headers.indexOf("id");
        const idPrecio = headers.indexOf("Precio");

        for (let fila of filas) {
          const id = fila[ID];
          const precio = fila[idPrecio];
          if (id) {
            precios[id] = precio;
          }
        }
      }
    }

    const combinados = [];
    for (let categoria in servicios) {
      const valor = servicios[categoria];
      if (Array.isArray(valor)) {
        valor.forEach((item) => {
          const precio = precios[item.id] || "no disponible";
          combinados.push({ ...item, precio });
        });
      } else if (typeof valor === "object") {
        const precio = precios[valor.id] || "no disponible";
        combinados.push({ ...valor, precio });
      }
    }

    return combinados;
  };

  const combinados = !cargando && !error ? combinar() : [];

  return { combinados, cargando, error };
};
